import React from 'react';
import { useMoviProducao } from '../../hooks/useMoviProducao';
import { formatCurrencyAsText } from '~/utils/functions';
import { FooterContainer, CanceladoContainer } from '../../styles';

export const Footer: React.FC = () => {
  const { totalizadores, flgCancelado } = useMoviProducao();
  return (
    <FooterContainer>
      <span className="tot">
        Custo Total/Qtde:{' '}
        {formatCurrencyAsText(totalizadores.tot_qtd_producao, 3, 3 || 0)} |
        Custo Total Produção:{' '}
        {formatCurrencyAsText(totalizadores.tot_custo_producao, 2, 2 || 0)}
      </span>
      {flgCancelado && (
        <CanceladoContainer>
          <h3 className="cancel">CANCELADO</h3>
        </CanceladoContainer>
      )}
    </FooterContainer>
  );
};
